module.exports = __webpack_public_path__ + "static/Syberia5-013b9dcde08aa2196d0b747b97540547.webp";